<template>
    <div class="access-text flex-row-with-gap" :class="{ shared: props.sharedText }">
        {{ accessText }}
        <access-traffic-light :access="access" v-if="!props.sharedText" />
    </div>
</template>

<script lang="ts" setup>
import { TAccess, TAccessReason } from '@/types/general/TAccess.ts';
import AccessTrafficLight from '@/components/common/AccessTrafficLight.vue';
import { computed } from 'vue';

const props = defineProps<{
    accessReason: TAccessReason;
    sharedText?: string | undefined;
}>();

const access = computed<TAccess>(() => {
    if (props.sharedText) return 'Full';
    if (props.accessReason === 'Full' || props.accessReason === 'Public' || props.accessReason === 'Trial') return 'Full';
    return props.accessReason;
});

const accessText = computed<string | null>(() => {
    if (props.sharedText) return props.sharedText;
    if (props.accessReason === 'Full') return 'Full access';
    if (props.accessReason === 'Public') return 'Public';
    if (props.accessReason === 'Trial') return 'Trial';
    if (props.accessReason === 'Partial') return 'Partial access';
    return 'No access';
});

</script>

<style lang="scss" scoped>

.access-text {
    background-color: var(--neutral300);
    border-radius: var(--borderRadiusOuter);
    font-size: var(--extraSmallFontSize);
    padding: var(--smallSpacing) var(--defaultSpacing);
    align-self: center;
    white-space: nowrap;
    &.shared {
        background-color: var(--accentColour);
        color: black;
        font-weight: bold;
    }
}

</style>
